"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSign = exports.selectLastTransact = exports.selectEthCallTimestampByKey = exports.selectEthCallTimestamp = exports.selectEthCallState = exports.selectEthCallMultiple = exports.selectEthCall = exports.selectCurrentChain = exports.selectBiggerSign = exports.getCallKey = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _reselect = require("reselect");
var _packageIndex = require("../../package-index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const {
  ethers
} = require("ethers");
const EMPTYSTATE = {};
const getCurrentChain = state => state.currentChain;
const getChainState = state => state.chainState;
const getChainStateCalls = state => {
  const chainId = getCurrentChain(state).id;
  const chainState = getChainState(state);
  return chainState[chainId] ? chainState[chainId].calls : {};
};
const getChainStateCallMetadata = state => {
  const chainId = getCurrentChain(state).id;
  const chainState = getChainState(state);
  return chainState[chainId] ? chainState[chainId].call_metadata : {};
};
const getChainStateEIPSigns = state => {
  const chainId = getCurrentChain(state).id;
  const chainState = getChainState(state);
  return chainState[chainId] && chainState[chainId].eipSigns ? chainState[chainId].eipSigns : {};
};
const getChainStatePlainSigns = state => {
  const chainId = getCurrentChain(state).id;
  const chainState = getChainState(state);
  return chainState[chainId] && chainState[chainId].signs ? chainState[chainId].signs : {};
};
const getChainStateTransacts = state => {
  const chainId = getCurrentChain(state).id;
  const chainState = getChainState(state);
  return chainState[chainId] && chainState[chainId].transacts ? chainState[chainId].transacts : [];
};
const getSignKey = (__, key, address) => {
  return `${key}_${address}`;
};
const getCallKey = function (state, address, abiName, method) {
  const rpc = state.currentChain.rpc;
  for (var _len = arguments.length, args = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
    args[_key - 4] = arguments[_key];
  }
  return address + "_" + (0, _packageIndex.getEncodedCallFn)(address, abiName, method, args, rpc);
};
exports.getCallKey = getCallKey;
const getCallKeys = (state, calls) => {
  const rpc = state.currentChain.rpc;
  return _lodash.default.map(calls, call => {
    return call.address + "_" + (0, _packageIndex.getEncodedCallFn)(call.address, call.abi, call.method, call.args, rpc);
  });
};
const selectCurrentChain = exports.selectCurrentChain = (0, _reselect.createSelector)([getCurrentChain], currentChain => currentChain);
const selectEthCall = exports.selectEthCall = (0, _reselect.createSelector)([getChainStateCalls, getCallKey], (calls, callKey) => calls && calls[callKey] && calls[callKey].value);
const selectEthCallTimestamp = exports.selectEthCallTimestamp = (0, _reselect.createSelector)([getChainStateCallMetadata, getCallKey], (callMeta, callKey) => callMeta && callMeta[callKey] && callMeta[callKey].timestamp);
const selectEthCallTimestampByKey = exports.selectEthCallTimestampByKey = (0, _reselect.createSelector)([getChainStateCallMetadata, (__, callKey) => callKey], (callMeta, callKey) => callMeta && callMeta[callKey] && callMeta[callKey].timestamp);
const selectEthCallState = exports.selectEthCallState = (0, _reselect.createSelector)([getChainStateCalls, getCallKey], (calls, callKey) => calls[callKey] && calls[callKey].state);
const selectEthCallMultiple = exports.selectEthCallMultiple = (0, _reselect.createSelector)([getChainStateCalls, getCallKeys], (calls, callKeys) => {
  return _lodash.default.map(callKeys, callKey => {
    return !calls || calls[callKey] === undefined ? EMPTYSTATE : calls[callKey];
  });
});
const selectLastTransact = exports.selectLastTransact = (0, _reselect.createSelector)([getChainStateTransacts], transacts => transacts[transacts.length - 1]);
const selectSign = exports.selectSign = (0, _reselect.createSelector)([getChainStatePlainSigns, getSignKey], (signs, signKey) => signs[signKey]);
const selectBiggerSign = exports.selectBiggerSign = (0, _reselect.createSelector)([getChainStateEIPSigns, (__, addr, nonce, spender) => ({
  addr,
  nonce,
  spender
})], (signs, params) => {
  const userAddr = ethers.getAddress(params.addr);
  const nonce = params.nonce;
  const spenderAddr = params.spender ? ethers.getAddress(params.spender) : "";
  const filteredSigns = Object.keys(signs).filter(sign => {
    return signs[sign].state === "SIGNED" && userAddr === ethers.getAddress(signs[sign].userAddress) && signs[sign].value.nonce === nonce && spenderAddr && spenderAddr === ethers.getAddress(signs[sign].value.spender);
  });
  const sortedSigns = filteredSigns.sort((s1, s2) => {
    return signs[s2].value.value - signs[s1].value.value;
  });
  return signs[sortedSigns[0]];
});